import styled from "@emotion/styled";

export const FormSection = styled.div`
  flex: 3;
`;

export const UploadSection = styled.div`
  flex: 1;
`;
